"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "transformerFelt", {
    enumerable: true,
    get: function() {
        return transformerFelt;
    }
});
var _has = /*#__PURE__*/ _interop_require_default(require("lodash/has"));
var _transformKonstanter = require("./transformerere/transformKonstanter");
var _isempty = /*#__PURE__*/ _interop_require_default(require("../utils/is-empty"));
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
/** Henter verdier fra data som er referert til i transformeren. Dersom de refererte dataene også har tilhørende
 * transformere så kjøres også disse.
 * @param transformerReferanserFelt - inneholder feltdefinsjoner for referanser som har transformere. Må sendes inn fra klient.
 * */ var getRefererteData = function(felt, data) {
    var transformerReferanserFelt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, transformerere = arguments.length > 3 ? arguments[3] : void 0, metodeNavn = arguments.length > 4 ? arguments[4] : void 0, options = arguments.length > 5 ? arguments[5] : void 0;
    var refererteData = Object.fromEntries(felt.transformer.referanser.filter(function(referanse) {
        return !(0, _isempty.default)(data[referanse]);
    }).map(function(referanse) {
        return [
            referanse,
            data[referanse]
        ];
    }));
    return Object.fromEntries(Object.entries(refererteData || {}).map(function(param) {
        var _param = _sliced_to_array(param, 2), referanse = _param[0], feltVerdi = _param[1];
        if ((0, _has.default)(transformerReferanserFelt[referanse], "transformer.id")) {
            var referanseFelt = transformerReferanserFelt[referanse];
            // Bruker referansens egen transformer, om finnes, ellers bruk verdien i data
            return [
                referanse,
                transformerere[referanseFelt.transformer.id][metodeNavn](referanseFelt, feltVerdi, options)
            ];
        }
        return [
            referanse,
            feltVerdi
        ];
    }));
};
var transformerFelt = function(transformerere) {
    var metodeNavn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "transform";
    return function(felt, data) {
        var _param = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _param_returnerDataOnMissingTransformer = _param.returnerDataOnMissingTransformer, returnerDataOnMissingTransformer = _param_returnerDataOnMissingTransformer === void 0 ? true : _param_returnerDataOnMissingTransformer, _param_transformerReferanserFelt = _param.transformerReferanserFelt, transformerReferanserFelt = _param_transformerReferanserFelt === void 0 ? {} : _param_transformerReferanserFelt, options = _object_without_properties(_param, [
            "returnerDataOnMissingTransformer",
            "transformerReferanserFelt"
        ]);
        if (!(felt && felt.transformer && transformerere[felt.transformer.id])) {
            return returnerDataOnMissingTransformer ? data : undefined;
        }
        var transformer = transformerere[felt.transformer.id];
        if (!transformer[metodeNavn]) {
            return data;
        }
        if (felt.transformer.referanser) {
            var refererteData = getRefererteData(felt, data, transformerReferanserFelt, transformerere, metodeNavn, options);
            switch(transformer.verditype){
                case _transformKonstanter.verditype.flere:
                    var _transformer;
                    return (_transformer = transformer)[metodeNavn].apply(_transformer, [
                        felt
                    ].concat(_to_consumable_array(Object.values(refererteData))));
                case _transformKonstanter.verditype.enkelt:
                    return transformer[metodeNavn](felt, Object.values(refererteData)[0], options);
                case _transformKonstanter.verditype.formatertTekst:
                    return transformer[metodeNavn](felt, _object_spread({}, data, refererteData), options);
                default:
                    console.warn("Transformer '".concat(felt.transformer.id, "' (").concat(transformer.description, ") for referanser mangler verditype"));
            }
        }
        return transformer[metodeNavn](felt, data, options);
    };
};
